







































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { zyScreenServer } from '@/api/installServer';
import Dialog2Detail from '@/views/dataView/ziYangDataViewBlack/unit/dialog/box6/dialog-2-1.vue';

@Component({
  components: { Dialog2Detail },
})
export default class CorrectRate extends Vue {
  private dialogVisible: any = false;

  queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  total: any = 0;
  tableData: any = [];
  hazardStatus: any = {
    CREATED: '已创建',
    ISSUED: '已下发',
    RECTIFYING: '整改中',
    RECTIFIED: '已整改',
    FEEDBACK: '已反馈',
    FINISH: '已完成',
    REVIEW_FAIL: '复查不通过',
    OTHERWISE: '另行办结',
  }; // 隐患状态

  private deptId: any = '';
  private filterForm: any = {};

  showDialog(data: any) {
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.filterForm.deptId = data.deptId ? data.deptId : '';
    this.getData();
    this.dialogVisible = true;
  }

  private handleSizeChange(size: number) {
    this.queryDataForm.pageSize = size;
    this.getData();
  }

  private handleCurrentChange(pageNo: number) {
    this.queryDataForm.pageNo = pageNo;
    this.getData();
  }

  getData() {
    zyScreenServer
      .getSecurityHazardOrRectifyNumList({
        pageNo: (this.queryDataForm as any).pageNo,
        pageSize: (this.queryDataForm as any).pageSize,
        inspectedUnitId: this.filterForm.deptId,
        closeFlag: true,
      })
      .then((res: any) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
        throw error;
      });
  }
  showDetail(item: any) {
    const refName = 'Dialog2Detail';
    const dialog = this.$refs[refName];
    (dialog as any).showDialog(item);
  }
  handleClose(done: any) {
    done();
  }
}
